import {Virtuoso} from 'react-virtuoso'
import {useFreelancerPaymentsDates} from '@features/payments/queries/useFreelancerPaymentsDates.ts'
import {Skeleton} from '@components/ui/skeleton'
import {ErrorBox} from '@components/commons/error-box'
import {useTranslation} from '@/translations/i18n.tsx'
import {PaymentsAccordion} from '@features/payments/components/payments-accordion.tsx'
import {AlertTriangleIcon} from '@components/ui/icon'
import {Button} from '@components/ui/button'

export const PaymentsList = () => {
    const {t} = useTranslation()
    const freelancerPaymentsDateQuery = useFreelancerPaymentsDates()

    //TODO add correct loading
    if (freelancerPaymentsDateQuery.isPending) {
        return <Skeleton height="100%" width="100%" />
    }
    if (freelancerPaymentsDateQuery.isError) {
        return (
            <ErrorBox
                title={t('errors:default')}
                icon={<AlertTriangleIcon />}
                cta={<Button onClick={() => freelancerPaymentsDateQuery.refetch()}>{t('commons:retry')}</Button>}
            />
        )
    }
    if (freelancerPaymentsDateQuery.remappedData.length == 0) {
        return (
            <div className="flex items-center justify-center text-xl text-neutral-500">{t('commons:no_results')}</div>
        )
    }

    return (
        <Virtuoso
            className="rounded-md bg-white"
            data={freelancerPaymentsDateQuery.remappedData}
            endReached={freelancerPaymentsDateQuery.fetchNextPage}
            overscan={100}
            itemContent={(_, item) => <PaymentsAccordion key={item.payment_date} paymentDate={item} />}
            components={{
                Footer: freelancerPaymentsDateQuery.isFetching ? () => <PaymentsAccordion isLoading /> : undefined
            }}
        />
    )
}
